import Panel from './Panel';

const Row = ({ label, value }) => (
  <div>
    <dt className="text-xs text-muted-foreground">{label}</dt>
    <dd className="text-sm font-medium break-words">{value || '—'}</dd>
  </div>
);

const AccountDetailsPanel = ({ name, email, regionConfig, onNavigate }) => (
  <Panel
    title="Account details"
    actionLabel="Settings"
    onViewAll={() => onNavigate('/settings')}
    testId="account-details"
  >
    <dl className="space-y-3">
      <Row label="Name" value={name} />
      <Row label="Email" value={email} />
      <Row label="Region" value={`${regionConfig.code} · ${regionConfig.currency}`} />
    </dl>
  </Panel>
);

export default AccountDetailsPanel;
